// DO NOT EDIT MANUALLY! This file is generated from Airtable: "Marketing"

import { Value } from './marketing.types';

const marketing: Value[] = [];
export default marketing;
